import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { register } from './reducers/todo-reducer';
import ModalComponent from './ModalCmpt';

const userData = ['interes_usuario', 'nombre', 'apPat', 'apMat', 'email','fechaNacimiento','educacion','codigoPostal'];

const initialState = {
    interes_usuario: "",
    nombre : "",
    apPat : "",
    apMat : "",
    fechaNacimiento: "",
    telLocal:"",
    telMovil: "",
    telOficina: "",
    email: "",
    pais: "México",
    estado: "",
    municipio:"",
    actividadActual:"",
    experienciaComercial:"Si",
	ingreso_mensual_requerido:"Menos de 20.000",
	educacion:"Licenciatura",
    mensaje: {},
    contacto:false,
    codigoPostal:"",
    aceptaaviso:"Si",
    aceptaterminos:"Si"
}

const fechaHoy = new Date();
const maxDate = `${fechaHoy.getFullYear() - 18}-${fechaHoy.getMonth()+1}-${fechaHoy.getDate()}`;
const minDate = `${fechaHoy.getFullYear() - 45}-${fechaHoy.getMonth()+1}-${fechaHoy.getDate()}`;
const anioMax = fechaHoy.getFullYear() - 18;
const anioMin = fechaHoy.getFullYear() - 45;

class App extends Component {
    constructor(props) {
        super(props);
        this.state = initialState;
        this.changeValues = this.changeValues.bind(this);
    }

    componentDidMount() {
        const _body = document.documentElement || document.body;
		const _chage = function() {
			window.parent.postMessage({frameHeight: _body.offsetHeight}, '*'); //NOSONAR
		};
		new window.ResizeObserver(_chage).observe(_body);
		new MutationObserver(_chage).observe(_body, { attributes: true, childList: true, characterData: true });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.successRegister) {
            if(nextProps.successRegister.exito){
                this.setState(initialState, () => {
                    this.setState({ propsModal: nextProps.successRegister, mostrar: true });
                });
            }else{
                this.setState({ propsModal: nextProps.successRegister, mostrar: true });
            }
        }
    }

    render() {
        return (
            <div className="formulario-cotiza">
                <div className="contenidoFormulario">

                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="col-md-6 col-sm-6 col-xs-6">
                            <div className="form-group">
                                <label htmlFor="interes_usuario">Mi interés es <span className="requiredIn">*</span></label>
                                <select id="interes_usuario" name="interes_usuario" className="form-control" onChange={this.changeValues.bind(this)}>
                                    <option value="">Seleccionar...</option>
                                    <option value="Soy agente y quiero unirme a GNP">Soy agente y quiero unirme a GNP</option>
                                    <option value="Quiero ser agente GNP">Quiero ser agente GNP</option>
                                    <option value="Quiero ser un director de agencia GNP">Quiero ser un director de agencia GNP</option>
                                </select>
                                {
                                    this.state.mensaje && this.state.mensaje.interes_usuario &&
                                        <p className="errorMsj">{this.state.mensaje.interes_usuario}</p>
                                }
                            </div>
                        </div>
                    </div>

                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="col-md-6 col-sm-6 col-xs-6">
                            <div className="form-group">
                                <label htmlFor="nombre">Nombre <span className="requiredIn">*</span></label>
                                <input type="text" className="form-control" id="nombre" 
                                value={this.state.nombre}
                                name="nombre" onChange={this.changeValues.bind(this)} />
                                {
                                    this.state.mensaje ? 
                                    this.state.mensaje.nombre ? <p className="errorMsj">{this.state.mensaje.nombre}</p> : null
                                    :null
                                }
                            </div>
                        </div>


                        <div className="col-md-6 col-sm-6 col-xs-6">
                            <div className="form-group">
                                <label htmlFor="apMat">Apellido Materno <span className="requiredIn">*</span></label>
                                <input type="text" className="form-control" id="apMat" name="apMat" value={this.state.apMat} onChange={this.changeValues.bind(this)} />
                                {
                                    this.state.mensaje && this.state.mensaje.apMat ? <p className="errorMsj">{this.state.mensaje.apMat}</p> : null
                                }
                            </div>
                        </div>
                    </div>


                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="col-md-6 col-sm-6 col-xs-6 desbordeInput">
                            <div className="form-group">
                                <label htmlFor="apPat">Apellido Paterno <span className="requiredIn">*</span></label>
                                <input type="text" className="form-control" id="apPat" 
                                value={this.state.apPat}
                                name="apPat" onChange={this.changeValues.bind(this)} />
                                {
                                    this.state.mensaje ? 
                                    this.state.mensaje.apPat ? <p className="errorMsj">{this.state.mensaje.apPat}</p> : null
                                    :null
                                }
                            </div>
                        </div>


                        <div className="col-md-6 col-sm-6 col-xs-6">
                            <div className="form-group">
                                <label htmlFor="fechaNacimiento">Fecha de Nacimiento <span className="requiredIn">*</span> </label>
                                <input type="date" max={maxDate} min={minDate} className="form-control" id="fechaNacimiento" name="fechaNacimiento" 
                                 value={this.state.fechaNacimiento}
                                onChange={this.changeValues.bind(this)} />
                                {
                                    this.state.mensaje ? 
                                    this.state.mensaje.fechaNacimiento ? <p className="errorMsj">{this.state.mensaje.fechaNacimiento}</p> : null
                                    :null
                                }
                            </div>
                        </div>
                    </div>


                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="col-md-12 col-sm-12 col-xs-12 etiquetaAzulBold">
                            Teléfonos
                        </div>
                

                        <div className="col-md-6 col-sm-6 col-xs-6">
                            <div className="form-group">
                                <label htmlFor="telLocal">Teléfono local </label>
                                <input type="text" className="form-control" id="telLocal" 
                                value={this.state.telLocal} maxLength="10"
                                name="telLocal" onChange={this.changeValues.bind(this)} />
                                {
                                    this.state.mensaje ? 
                                    this.state.mensaje.telLocal ? <p className="errorMsj">{this.state.mensaje.telLocal}</p> : null
                                    :null
                                }
                            </div>
                        </div>


                        <div className="col-md-6 col-sm-6 col-xs-6">
                            <div className="form-group">
                                <label htmlFor="telMovil">Teléfono móvil </label>
                                <input type="text" className="form-control" id="telMovil" 
                                value={this.state.telMovil} maxLength="10"
                                name="telMovil" onChange={this.changeValues.bind(this)} />
                                {
                                    this.state.mensaje ? 
                                    this.state.mensaje.telMovil ? <p className="errorMsj">{this.state.mensaje.telMovil}</p> : null
                                    :null
                                }
                            </div>
                        </div>
                    </div>


                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="col-md-6 col-sm-6 col-xs-6 desbordeInput">
                            <div className="form-group">
                                <label htmlFor="telOficina">Teléfono oficina </label>
                                <input type="text" className="form-control" id="telOficina" 
                                value={this.state.telOficina} maxLength="10"
                                name="telOficina" onChange={this.changeValues.bind(this)} />
                                {
                                    this.state.mensaje ? 
                                    this.state.mensaje.telOficina ? <p className="errorMsj">{this.state.mensaje.telOficina}</p> : null
                                    :null
                                }
                            </div>
                        </div>


                        <div className="col-md-6 col-sm-6 col-xs-6">
                            <div className="form-group">
                                <label htmlFor="email">Correo Electrónico <span className="requiredIn">*</span></label>
                                <input type="text" className="form-control" id="email" 
                                value={this.state.email}
                                name="email" onChange={this.changeValues.bind(this)} />
                                {
                                    this.state.mensaje ? 
                                    this.state.mensaje.email ? <p className="errorMsj">{this.state.mensaje.email}</p> : null
                                    :null
                                }
                            </div>
                        </div>
                    </div>


                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="col-md-6 col-sm-6 col-xs-12">
                            <div className="form-group">
                                <label htmlFor="codigoPostal">Código Postal <span className="requiredIn">*</span></label>
                                <input type="text" className="form-control" id="codigoPostal" maxLength="5"
                                    value={this.state.codigoPostal}
                                    name="codigoPostal" onChange={this.changeValues.bind(this) } 
                                    onKeyUp={this.postalCodeInfo.bind(this)}/>
                                {
                                    this.state.mensaje ? 
                                    this.state.mensaje.codigoPostal ? <p className="errorMsj">{this.state.mensaje.codigoPostal}</p> : null
                                    :null                                
                                }
                            </div>
                        </div>


                        <div className="col-md-6 col-sm-6 col-xs-12">
                            <div className="form-group">
                                <label htmlFor="estado">Estado</label>
                                <input type="text" className="form-control" id="estado" 
                                    value={this.state.estado}
                                    name="estado" onChange={this.changeValues.bind(this)} />
                                {
                                    this.state.mensaje ? 
                                    this.state.mensaje.estado ? <p className="errorMsj">{this.state.mensaje.estado}</p> : null
                                    :null
                                }
                            </div>
                        </div>
                    </div>


                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="col-md-6 col-sm-6 col-xs-12">
                            <div className="form-group">
                                <label htmlFor="municipio">Municipio </label>
                                <input type="text" className="form-control" id="municipio" value={this.state.municipio} name="municipio" onChange={this.changeValues.bind(this)} />
                                {
                                    this.state.mensaje ? 
                                    this.state.mensaje.municipio ? <p className="errorMsj">{this.state.mensaje.municipio}</p> : null
                                    :null
                                }
                            </div>
                        </div>
                    </div>


                    <div className="col-md-12 col-sm-12 col-xs-12 col-lg-12">
                        <div className="col-md-12 col-sm-12 col-xs-12 col-lg-12">
                            <hr/>
                        </div>
                    </div>


                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="col-md-6 col-sm-6 col-xs-6">
                            <div className="form-group">
                                <label htmlFor="educacion">Educación <span className="requiredIn">*</span></label>
                                <select id="estado" name="educacion" className="form-control" onChange={this.changeValues.bind(this)}>
                                    <option value="Posgrado">Posgrado</option>
                                    <option value="Licenciatura" selected={true}>Licenciatura</option>
                                    <option value="Pasante">Pasante</option>
                                    <option value="Preparatoria">Preparatoria</option>
                                    <option value="Otro">Otro</option>
                                </select>
                                {
                                    this.state.mensaje ? 
                                    this.state.mensaje.educacion ? <p className="errorMsj">{this.state.mensaje.educacion}</p> : null
                                    :null
                                }
                            </div>
                        </div>


                        <div className="col-md-6 col-sm-6 col-xs-6">
                            <div className="form-group">
                                <label htmlFor="actividadActual">Actividad Actual</label>
                                <input type="text" className="form-control" id="actividadActual" 
                                value={this.state.actividadActual} 
                                name="actividadActual" onChange={this.changeValues.bind(this)} />
                                {
                                    this.state.mensaje ? 
                                    this.state.mensaje.actividadActual ? <p className="errorMsj">{this.state.mensaje.actividadActual}</p> : null
                                    :null
                                }
                            </div>
                        </div>
                    </div>


                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="col-md-6 col-sm-6 col-xs-12">
                            <div className="form-group">
                                <label htmlFor="experienciaComercial">Experiencia Comercial</label>
                                <select id="experienciaComercial" name="experienciaComercial" className="form-control" onChange={this.changeValues.bind(this)}>
                                <option value="Si">Si</option>
                                <option value="No">No</option>
                              {/*value={this.state.experienciaComercial} 
                                name="experienciaComercial" onChange={this.changeValues.bind(this)} />*/}
                                </select>
                                {
                                    this.state.mensaje ? 
                                    this.state.mensaje.experienciaComercial ? <p className="errorMsj">{this.state.mensaje.experienciaComercial}</p> : null
                                    :null
                                }
                            </div>
                        </div>
                    </div>


                    <div className="col-md-12 col-sm-12 col-xs-12 col-lg-12">
                        <div className="col-md-12 col-sm-12 col-xs-12 col-lg-12">
                            <hr/>
                        </div>
                    </div>


                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="col-md-12 col-sm-12 col-xs-12 etiquetaAzulBoldRequerido">
                            Ingreso Mensual Requerido:
                        </div>

                    
                        <div className="col-md-6 col-sm-6 col-xs-12">
                            <div className="form-group">
                                <select id="ingreso_mensual_requerido" name="ingreso_mensual_requerido" className="form-control" onChange={this.changeValues.bind(this)}>
                                    <option value="20.000 a 40.000">$20,000 a $40,000</option>
                                    <option value="de 40.000 a 60.000">$40,000 a $60,000</option>
                                    <option value="de 60.000 a 80.000">$60,000 a $80,000</option>
                                    <option value="de 80.000 a 100.000">$80,000 a $100,000</option>
                                    <option value="Mas de 100.000">Más de $100,000</option>
                                </select>
                            </div>
                        </div>
                    </div>


                    <div className="col-md-12 col-sm-12 col-xs-12 col-lg-12">
                            <hr/>
                    </div>


                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="col-md12 col-sm-12 col-xs-12">
                            <div id="avisoPrivacidad">
                                <input type="checkbox"
                                    name="list" onClick={this.selectA} id="aceptarAviso"
                                />
                                <span id="avisoPrivacidad-1">Conozco y entiendo que mis datos son tratados conforme al</span>
                                <span id="avisoPrivacidad-2" style={{ marginLeft: "-10px" }} onClick={this.showAviso}>Aviso de privacidad de GNP</span>
                            </div>


                            <div id="terminosCondiciones" style={{ marginTop: "20px" }}>
                                <input type="checkbox"
                                    name="list" onClick={this.selectA} id="aceptarTerminos"
                                />
                                <span id="terminosCondiciones-1">He leído y acepto los</span>
                                <span id="terminosCondiciones-2" style={{ marginLeft: "-10px" }} onClick={this.showTerminos}>Términos y condiciones de uso de Medios Electrónicos</span>
                                <span id="terminosCondiciones-3" style={{ marginLeft: "-10px" }}>de Grupo Nacional Provincial S.A.B.</span>
                            </div>
                        </div>
					</div> 

                    <div className="col-md-12 col-sm-12 col-xs-12 col-lg-12">
                            <hr/>
                    </div>

                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="col-md-12 col-sm-12 col-xs-12  text-center" id="Primero">
                            <button type="button" id="btn-enviarF"className="btn btn-gnp" disabled>
                                Enviar <span className="glyphicon glyphicon-triangle-right"></span> 
                            </button>
                        </div>

                        <div className="col-md-12 col-sm-12 col-xs-12  text-center" id="Segundo">
                            <button type="button" id="btn-enviarF"className="btn btn-gnp" onClick={this.enviar.bind(this)}>
                                Enviar <span className="glyphicon glyphicon-triangle-right"></span> 
                            </button>
                        </div>
                    </div>
                    <ModalComponent propsModal={this.state.propsModal} mostrar={this.state.mostrar} />
                </div>
            </div>
        );
    }

    selectA() {
        var AvisoAceptacion = document.getElementById("aceptarAviso").checked;
        var TerminosAceptacion = document.getElementById("aceptarTerminos").checked;

        if (AvisoAceptacion === true && TerminosAceptacion === true){
            document.getElementById("Primero").style.display='none';
            document.getElementById("Segundo").style.display='block';
        }else{
            document.getElementById("Primero").style.display='block';
            document.getElementById("Segundo").style.display='none';
        }
	}

    showAviso(){
        const URLAP = (window.location !== window.parent.location) ? document.referrer: document.location;
        const link = document.createElement('a');
        link.href = URLAP + "aviso-de-privacidad/candidatos-a-agentes";
        link.target = '_blank';
        link.click();
    }

    showTerminos(){
        const URLTC = (window.location !== window.parent.location) ? document.referrer: document.location;
        const link = document.createElement('a');
        link.href = URLTC + "uso-de-medios-electronicos";
        link.target = '_blank';
        link.click();
    }

    cancelar(event) {
        this.setState(initialState, () => {
            this.setState({ mostrar: false });
        });
    }

    changeValues(event) {
        var name = event.target.name;
        var value = event.target.value;
        var mensaje = this.state.mensaje;
        var target = event.target;

        if(target.type==="checkbox"){
            if(target.checked){
                this.setState({contacto:true});
            }else{
                this.setState({contacto:false});
            }
        }
        mensaje[name] = null;
        this.setState({ [name]: value, mensaje, mostrar: false });
    }

    postalCodeInfo(codigoPostal){
        if(this.state.codigoPostal.length === 5){
            console.log("Se quita el api porque ya no funciona");
        }
    }

    getUserAgent() {
        const ua = navigator.userAgent;
        let dispositvo;
        if (
          /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(
            ua
          )
        ) {
          dispositvo = 'Mobile';
        } else if (/Chrome/i.test(ua)) {
          dispositvo = 'Desktop';
        } else {
          dispositvo = 'Desktop';
        }
        return dispositvo;
    }


    enviar(event){
        this.setState({mostrar:false});
        var mensaje = this.state.mensaje;
        var valido = true;
        console.log(this.state);

        for(var i=0; i < userData.length; i++){
            var re;
            var plural=false;
            var msjToShow = null;
            if(!this.state[userData[i]]){
                mensaje[userData[i]] = "Campo requerido.";
                valido=false;
            }else if(this.state[userData[i]].trim()===""){
                mensaje[userData[i]] = "Campo requerido.";
                valido=false;
            }else{
                switch (userData[i]) {
                    case 'email':
                      re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                      msjToShow = "un correo válido."
                      break;
                    case 'telefono':
                      re = /^\d{10}$/;
                      msjToShow="un télefono válido.";
                      break;
                    case 'codigoPostal':
                      re = /^\d{5}$/;
                      msjToShow="un código válido.";
                      break;
                    case 'apPat':
                      re = /^[a-z\u00E0-\u00FC ]+$/i;
                      msjToShow="un apellido paterno válido.";
                      break;
                    case 'apMat':
                        re = /^[a-z\u00E0-\u00FC ]+$/i;
                        msjToShow="un apellido materno válido.";
                        break;
                    case 'nombre':
                        msjToShow="un nombre válido.";
                      re = /^[a-z\u00E0-\u00FC ]+$/i;
                      break;
                    case 'municipio':
                      re = /^[a-z\u00E0-\u00FC ]+$/i;
                      msjToShow=" una ciudad de residencia válida.";
                      break;
                    case 'educacion':
                        re = /^[a-z\u00E0-\u00FC ]+$/i;
                        msjToShow=" una educación válida.";
                        break;
                    case 'fechaNacimiento':
                        re = null;
                        msjToShow=" una fecha de nacimiento válida."
                      break;
                    default:
                      console.log(userData[i])
                  }

                if(re){
                  if(!re.test(this.state[userData[i]]) ){
                    if (plural) {
                      mensaje[userData[i]] = "Capture " + msjToShow + " válidos.";
                    } else {
                        mensaje[userData[i]]  = "Capture " + (msjToShow ? msjToShow : userData[i]) ;
                    }
                    valido=false;
                  }
                }
            }
        }

         //Campos no requeridos pero en caso de estar validarlos
        var reTel = /^\d{10}$/;

        if(this.state.telLocal){
            if(!reTel.test(this.state.telLocal)){
                mensaje.telLocal = "Capture un teléfono local válido."
                 valido=false;
            }
        }

        if(this.state.telMovil){
            if(!reTel.test(this.state.telMovil)){
                mensaje.telMovil = "Capture un teléfono móvil válido."
                valido=false;
            }
        }

        if(this.state.telOficina){
            if(!reTel.test(this.state.telOficina)){
                mensaje.telOficina = "Capture un teléfono de oficina válido."
                valido=false;
            }
        }

        if(this.state.fechaNacimiento){
            const splitFecha = this.state.fechaNacimiento.split("-");
            const anioSelected = parseInt(splitFecha[0]);
            if(anioSelected > anioMax || anioSelected < anioMin){
                mensaje.fechaNacimiento = `Capture una fecha de nacimiento válida entre ${anioMin} - ${anioMax}.`;
                valido=false;
            }
        }

       this.setState({mensaje});
        if(valido){
            window.dataLayer.push({
                'event': 'virtualEvent',
                'Proceso': 'Registro',
                'TipoEvento': 'Interacción',
                'TipoZona': 'Blue Navigation',
                'Zona': 'Quiero ser Agente GNP',
                'SubZona': 'Undefined',
                'Pantalla': 'Nuestros agentes',
                'Sección': 'Registrar Datos',
                'TipoElemento': 'Button',
                'Intención': 'Registrar solicitud',
                'CTA': 'Enviar',
                'LeadId': '0',
                'PagePath': window.location.pathname,
                'TimeStamp': Date.now(),
                'TipoDispositivo': this.getUserAgent()
            });
            this.props.actions.register(this.state);
            document.getElementById("aceptarTerminos").checked=false;
            document.getElementById("aceptarAviso").checked=false;
            document.getElementById("Primero").style.display='block';
            document.getElementById("Segundo").style.display='none';
        }
     }
}

const mapStateToProps = (state) => {
    return {
      successRegister: state.todoReducer.get("successRegister"),
      failAction: state.todoReducer.get("failAction")
    };
  }

  const mapDispatchToProps = (dispatch) => {

    return {
        actions: bindActionCreators({
          register : register
       }, dispatch)
    }
  }

  export default connect(
    mapStateToProps,
    mapDispatchToProps

  )(App);


// WEBPACK FOOTER //
// ./src/App.js



// WEBPACK FOOTER //
// ./src/App.js